define('libs/jquery',[],function()
{
	if(!window.jQuery) throw Error('jQuery is missing');
	return window.jQuery;
});
